import { z } from 'zod';

export const pulseTagUserSchema = z.object({
  id: z.number(), shortCode: z.string(), name: z.string(), color: z.string(),
  role: z.string(), assigned: z.boolean(), lead: z.boolean(), taggable: z.boolean().optional(),
});
export const pulseTagStateSchema = z.object({
  userId: z.number(), version: z.string(), active: z.boolean(), urgent: z.boolean(),
  message: z.string(), taggedBy: z.number().nullable(), taggedAt: z.string().nullable(),
  readAt: z.string().nullable(),
});
export type PulseTagUser = z.infer<typeof pulseTagUserSchema>;
export type PulseTagState = z.infer<typeof pulseTagStateSchema>;
export const canReceivePulseTag = (user: PulseTagUser) => user.taggable ?? user.assigned;
/** A read before the latest tag is not an acknowledgement of that tag. */
export function hasUnreadPulseTag(tag?: PulseTagState) {
  if (!tag?.active) return false;
  if (!tag.readAt) return true;
  return tag.taggedAt !== null && !(Date.parse(tag.readAt) >= Date.parse(tag.taggedAt));
}
export const PULSE_TAG_UNDO_MS = 120_000;
export function canClearPulseTag(tag: PulseTagState, actorId: number, now = Date.now()) {
  return tag.active && (tag.userId === actorId || (
    tag.taggedBy === actorId && tag.taggedAt !== null &&
    now - Date.parse(tag.taggedAt) >= 0 && now - Date.parse(tag.taggedAt) < PULSE_TAG_UNDO_MS
  ));
}
export function sortPulseTagUsers(users: PulseTagUser[], viewerId: number) {
  const rank = (u: PulseTagUser) => u.id === viewerId ? 0 : u.role === 'admin' ? 1 : u.lead ? 2 : 3;
  return [...users].sort((a, b) => rank(a) - rank(b) || a.shortCode.localeCompare(b.shortCode) || a.id - b.id);
}
